/**
 * Extrait le message métier d'une réponse Edge Function (status 4xx/5xx).
 * @param {unknown} invokeError
 * @param {Record<string, unknown> | null} payload
 */
export async function getEdgeFunctionErrorMessage(invokeError, payload) {
  if (payload?.error) {
    const e = payload.error;
    if (typeof e === 'string') return e;
    if (e && typeof e === 'object' && 'message' in e && typeof e.message === 'string') {
      return e.message;
    }
  }

  if (!invokeError || typeof invokeError !== 'object') return null;

  const ctx = invokeError.context;
  if (ctx && typeof ctx.json === 'function') {
    try {
      const body = await ctx.json();
      if (body?.error) {
        return typeof body.error === 'string' ? body.error : body.error?.message;
      }
      if (body?.message) return body.message;
    } catch {
      /* corps non JSON */
    }
  }

  if (typeof invokeError.message === 'string' && invokeError.message !== 'Edge Function returned a non-2xx status code') {
    return invokeError.message;
  }

  return null;
}
